import React from 'react';

const SvgCh = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="CH_svg__a" x={0} y={0} width="100%" height="100%" rx={1} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="CH_svg__b" fill="#fff">
        <use xlinkHref="#CH_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#CH_svg__a" />
      <path fill="red" mask="url(#CH_svg__b)" d="M0 0h28v20H0z" />
      <path
        d="M12 12H8.341A.34.34 0 0 1 8 11.659V8.341A.34.34 0 0 1 8.341 8H12V4.341A.34.34 0 0 1 12.341 4h3.318a.34.34 0 0 1 .341.341V8h3.659a.34.34 0 0 1 .341.341v3.318a.34.34 0 0 1-.341.341H16v3.659a.34.34 0 0 1-.341.341h-3.318a.34.34 0 0 1-.341-.341V12z"
        fill="#FFF"
        mask="url(#CH_svg__b)"
      />
    </g>
  </svg>
);

export default SvgCh;
